'use client';
import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import { Product } from './menuData';

interface ProductCardProps {
  product: Product;
  onQuickAdd: () => void;
  onCustomize: () => void;
}

export default function ProductCard({ product, onQuickAdd, onCustomize }: ProductCardProps) {
  return (
    <div className="bg-card rounded-2xl overflow-hidden card-shadow hover:card-shadow-lg transition-all duration-200 flex flex-col">
      <div className="relative">
        <AppImage
          src={product.image}
          alt={product.alt}
          width={200}
          height={150}
          className="w-full h-32 object-cover"
        />
        {product.popular && (
          <span className="absolute top-2 left-2 bg-primary text-white text-[10px] font-bold px-2 py-0.5 rounded-full">
            Popüler
          </span>
        )}
        {product.seasonal && (
          <span className="absolute top-2 right-2 bg-gold text-white text-[10px] font-bold px-2 py-0.5 rounded-full">
            Sezonluk
          </span>
        )}
      </div>
      <div className="p-3 flex flex-col flex-1">
        <h3 className="text-foreground font-bold text-sm leading-tight mb-1">{product.name}</h3>
        <p className="text-muted-foreground text-[11px] leading-relaxed flex-1 mb-2">{product.description}</p>
        <div className="flex items-center gap-1 mb-3">
          <span className="text-muted-foreground text-[10px]">{product.calories} kal</span>
          <span className="text-muted-foreground text-[10px]">·</span>
          {product.tags.slice(0, 1).map((tag) => (
            <span key={`tag-${product.id}-${tag}`} className="text-[10px] text-primary font-medium">{tag}</span>
          ))}
        </div>
        <div className="flex items-center justify-between">
          <span className="text-foreground font-bold text-base">₺{product.price}</span>
          <div className="flex items-center gap-1">
            <button
              onClick={onCustomize}
              className="w-7 h-7 rounded-full border border-border flex items-center justify-center hover:bg-muted transition-colors"
              title="Özelleştir"
            >
              <Icon name="AdjustmentsHorizontalIcon" size={14} className="text-muted-foreground" />
            </button>
            <button
              onClick={onQuickAdd}
              className="w-7 h-7 rounded-full bg-primary text-white flex items-center justify-center hover:bg-primary/90 transition-colors active:scale-90"
            >
              <Icon name="PlusIcon" size={16} className="text-white" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}